import { useAuthContext } from '~/shared/context/useAuthContext';
import { useOrganizationStatus } from '~/shared/utils/organizationUtils';

export function useVolumeExclusionGuard(accountId?: string) {
  const { accounts, activeTenantId } = useAuthContext();
  const { isOrganizationAccount } = useOrganizationStatus(accounts, activeTenantId);
  const isMissingOrgAccount = isOrganizationAccount && !accountId;

  return { isMissingOrgAccount };
}
